import api from './api';

export const switchOrganizationPrimary = async (organizationId) => {
  const response = await api.post('/organization-switch-primary', {
    organization_id: organizationId,
  });
  return response.data;
};

export const createAdditionalOrganization = async (payload) => {
  const response = await api.post('/organization-create-additional', payload);
  return response.data;
};
